import { GameMetadata } from "@/pages/subs/play/common/game-registry";
import { GameAdapter } from "@/pages/subs/play/common/game-adapter";
import { PlayHeader } from "@/pages/subs/play/play-header";
import { useState } from "react";
import { GameList } from "./game-list";

export const LocalView = ({
  games,
  goToSelectMode,
}: {
  games: GameMetadata[];
  goToSelectMode: () => void;
}) => {
  const [selectedGame, setSelectedGame] = useState<GameMetadata | null>(null);

  const renderLocalView = () => {
    // 게임 선택 시 전체 화면으로 게임 렌더링
    if (selectedGame) {
      return (
        <div className="w-full h-full">
          <GameAdapter game={selectedGame} mode="local" />
        </div>
      );
    }

    return <GameList games={games} setSelectedGame={setSelectedGame} />;
  };

  return (
    <div className="w-full h-full flex flex-col">
      <PlayHeader
        game={selectedGame}
        title={selectedGame ? "🎮 게임 플레이" : "🎮 로컬 게임"}
        onClickBack={() => {
          if (selectedGame) {
            setSelectedGame(null);
          } else {
            goToSelectMode();
          }
        }}
      />
      <div className="flex-1">{renderLocalView()}</div>
    </div>
  );
};
